import type { LanguageCode, StringParams } from './types';

/**
 * Microsoft.Extensions.Localization.IStringLocalizer benzeri JSON sözlük servisi.
 * Kaynaklar: src/localization/locales/{lang}/*.json
 */
export class JsonLocalizationService {
  private readonly store = new Map<LanguageCode, Record<string, string>>();

  load(language: LanguageCode, dictionary: Record<string, string>): void {
    const current = this.store.get(language) ?? {};
    this.store.set(language, { ...current, ...dictionary });
  }

  getDictionary(language: LanguageCode): Readonly<Record<string, string>> {
    return this.store.get(language) ?? {};
  }

  getString(language: LanguageCode, key: string, params?: StringParams): string | undefined {
    const template = this.store.get(language)?.[key];
    if (template === undefined) return undefined;
    return interpolate(template, params);
  }

  hasKey(language: LanguageCode, key: string): boolean {
    return Boolean(this.store.get(language)?.[key]);
  }
}

export function interpolate(template: string, params?: StringParams): string {
  if (!params) return template;
  return Object.entries(params).reduce((result, [name, value]) => {
    const safe = value == null ? '' : String(value);
    return result.replace(new RegExp(`{{\\s*${escapeRegExp(name)}\\s*}}`, 'g'), safe);
  }, template);
}

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
